module.exports = __webpack_public_path__ + "static/img/home-icon1.d0c54eac.png";